// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'project-template.page.title': 'Project Templates',
    'project-template.page.archive.title': 'Archived Templates',
    'project-template.page.bin.title': 'Binned Templates',
    'project-template.page.search_results': 'Search Results',
    'project-template.page.create.title': 'New Template',
    'project-template.page.search.title': 'Find Templates',
    'project-template.page.edit.title': 'Edit Template',
    'project-template.page.view.title': 'View Template',
    'project-template.page.all': 'All',

    'project-template.button.cancel': 'Cancel',
    'project-template.button.select': 'Select',
    'project-template.button.find': 'Find Templates',
    'project-template.button.search': 'Apply',
    'project-template.button.create': 'Create Template',
    'project-template.button.new': 'New Template',
    'project-template.button.save': 'Save Changes',
    'project-template.button.archive': 'Archive Project',
    'project-template.button.bin': 'Bin Project',
    'project-template.button.empty': 'Empty Bin',
    'project-template.button.delete': 'Permanently Delete',
    'project-template.button.edit': 'Edit Project',
    'project-template.button.restore': 'Restore',
    'project-template.button.reset': 'Reset',
    'project-template.button.convert_from_template': 'Create as Project',

    'project-template.placeholder.search': 'Search templates',

    'project-template.link.create_first_project_template': 'Click here to create your first template',
    'project-template.link.project_templates': ' Return to Templates',
    'project-template.link.archive': 'Archived Templates',
    'project-template.link.bin': 'Binned Templates',
    'project-template.link.retry': 'Click here to retry',

    'project-template.checkbox.all': 'Check All',
    'project-template.checkbox.actions_label': 'with selected',

    'project-template.label.project_type_name': 'Project Type',
    'project-template.label.entity_name': 'Client',
    'project-template.label.title': 'Title',
    'project-template.label.description': 'Description',

    'project-template.sort.field_label': 'Field',
    'project-template.sort.direction_label': 'Direction',
    'project-template.sort.direction_ascending': 'Ascending',
    'project-template.sort.direction_descending': 'Descending',

    'project-template.modal.title.project_template_archive': 'Archive Template',
    'project-template.modal.title.project_template_bin': 'Bin Template',
    'project-template.modal.title.project_template_bin_empty': 'Delete All Binned Templates',
    'project-template.modal.title.project_template_delete_permanently': 'Delete Template',
    'project-template.modal.title.project_template_restore': 'Restore Template',
    'project-template.modal.title.template_to_project': 'Create as Project',

    'project-template.modal.message.template_to_project': 'You are about to create a project from this template. This will include active checklists and tasks.',
    'project-template.modal.message.project_template_archive': 'Are you sure that you want to archive this template? | Are you sure that you want to archive these templates?',
    'project-template.modal.message.project_template_bin': 'Are you sure that you want to move this template to the bin? | Are you sure that you want to move these templates to the bin?',
    'project-template.modal.message.project_template_bin_empty': 'Are you sure that you want to permanently delete all binned templates? This action cannot be undone!',
    'project-template.modal.message.project_template_delete_permanently':
        'Are you sure that you want to permanently delete this template? This action cannot be undone. | Are you sure that you want to permanently delete these templates? This action cannot be undone.',
    'project-template.modal.message.project_template_restore': 'Are you sure that you want to restore this template? | Are you sure that you want to restore these templates?',

    'project-template.success.message.project_template_created': 'Your template has been created',
    'project-template.success.message.project_template_updated': 'Your template has been updated',
    'project-template.success.message.project_template_restored': 'Your template has been restored | All selected templates were restored',
    'project-template.success.message.project_template_deleted': 'Your template has been permanently deleted | All selected templates were permanently deleted',
    'project-template.success.message.archived_project_templates': 'Your template was moved to the archive | All selected templates were moved to the archive',
    'project-template.success.message.binned_project_templates': 'Your template was moved to the bin | All selected templates were moved to the bin',
    'project-template.success.message.project_template_bin_emptied': 'All binned templates were permanently deleted!',

    'project-template.error.message.archived_project_templates': 'This template was already moved to the archive | These templates were already moved to the archive',
    'project-template.error.message.binned_project_templates': 'This template was already moved to the bin | These templates were already moved to the bin',
    'project-template.error.message.project_template_bin_emptied': 'All binned templates were already deleted',
    'project-template.error.message.project_template_deleted': 'This template was already permanently deleted | These templates were already permanently deleted',
    'project-template.error.message.project_template_restored': 'This template was already restored | These templates were already restored',
    'project-template.error.message.error_loading_page': 'Sorry, there was an error loading template.| Sorry, there was an error loading templates.',

    'project-template.message.search.no_archived_project_templates': "You don't have any archived templates.",
    'project-template.message.search.no_binned_project_templates': "You don't have any binned templates.",
};
